import { TYPE_STRING } from './input-types';

export const id = 'customField1';
export const apiKey = 'CustomField1';
export const type = TYPE_STRING;

export const customField1 = {
  id,
  apiKey,
  type,
};
